import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) { k++; } groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
(function () {
  "use strict";

  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._book_1pxem_1{text-align:left}._details_1pxem_5{margin-top:.5em}._title_1pxem_9{font-weight:700;font-size:1.1em;margin-bottom:.25em}._subtitle_1pxem_15,._author_1pxem_19{margin-bottom:.25em}._image_27awu_1{display:block;-o-object-fit:contain;object-fit:contain;width:100%;aspect-ratio:2 / 3;position:relative;z-index:2;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}._cover_27awu_13{background-size:cover;background-repeat:no-repeat;background-position:50% 0;transition:opacity .25s ease-in-out}._shelf_186u5_1{display:grid;justify-content:space-around;align-items:top}._groupTitle_1e2wf_1{font-size:2em;margin-bottom:.5em}._group_1e2wf_1{margin-bottom:2em}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
import Ue, { useState as B, useEffect as We, useRef as mt, useMemo as pt } from "react";
var gt = function gt(t, n) {
    var o = new URL("https://www.goodreads.com/review/list/".concat(t.userId));
    return o.searchParams.set("shelf", t.shelf || "read"), o.searchParams.set("sort", t.sort || "date_read"), o.searchParams.set("order", t.order || "d"), o.searchParams.set("page", String(n)), t.search && o.searchParams.set("search[query]", t.search), new URL("https://cors.kylekarpack.workers.dev/corsproxy/?apiurl=".concat(encodeURIComponent(o.toString())));
  },
  yt = function yt(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
    var l = new DOMParser().parseFromString(t, "text/html").querySelectorAll("tr"),
      g = Array.from(l);
    var v;
    return typeof n != "number" ? v = parseInt(n) || 100 : v = n, g.map(function (m) {
      return bt(m, v);
    });
  },
  bt = function bt(t, n) {
    var q, w, k, V, Z, G, J, H, X, D, K, Q, N, T;
    var o = (w = (q = t == null ? void 0 : t.querySelector("td.field.isbn .value")) == null ? void 0 : q.textContent) == null ? void 0 : w.trim(),
      d = (V = (k = t == null ? void 0 : t.querySelector("td.field.asin .value")) == null ? void 0 : k.textContent) == null ? void 0 : V.trim();
    var l = (G = (Z = t == null ? void 0 : t.querySelector("td.field.title a")) == null ? void 0 : Z.getAttribute("title")) != null ? G : "";
    var g = (H = (J = t == null ? void 0 : t.querySelector("td.field.author .value")) == null ? void 0 : J.textContent) == null ? void 0 : H.trim().replace(" *", "").split(", ").reverse().join(" "),
      v = (D = (X = t == null ? void 0 : t.querySelector("td.field.cover img")) == null ? void 0 : X.getAttribute("src")) == null ? void 0 : D.replace(/\._(S[Y|X]\d+_?){1,2}_/i, "._SX".concat(n * 2, "_")),
      m = (K = t == null ? void 0 : t.querySelector("td.field.cover a")) == null ? void 0 : K.getAttribute("href"),
      u = (Q = t == null ? void 0 : t.querySelectorAll("td.field.rating .staticStars .p10")) == null ? void 0 : Q.length,
      y = (N = t == null ? void 0 : t.querySelector("td.field.date_read .date_read_value")) == null ? void 0 : N.textContent,
      h = (T = t == null ? void 0 : t.querySelector("td.field.date_added span")) == null ? void 0 : T.textContent,
      L = y ? new Date(y) : void 0,
      _ = h ? new Date(h) : void 0;
    var C = "";
    var P = l.split(":");
    P.length > 1 && (l = P[0], C = P[1]);
    var z = l.match(/\(.*\)/);
    if (z) {
      var _z = _slicedToArray(z, 1),
        O = _z[0];
      C = O.replace("(", "").replace(")", ""), l = l.replace(O, "");
    }
    return {
      id: "".concat(o || d || window.crypto.randomUUID()),
      isbn: o,
      asin: d,
      title: l,
      subtitle: C,
      author: g,
      imageUrl: v,
      rating: u,
      dateRead: L,
      dateAdded: _,
      link: "https://www.goodreads.com/".concat(m)
    };
  },
  Lt = 30,
  Be = "All",
  _t = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      var m, n, o, d, l, u, g, v, _u, y, h;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return De(1, t);
            case 2:
              n = _context.sent;
              o = Math.min((m = t.limit) != null ? m : 10, n.status.total);
              d = Math.ceil(o / Lt);
              l = [];
              for (u = 2; u <= d; u++) {
                l.push(De(u, t));
              }
              _context.next = 9;
              return Promise.all(l);
            case 9:
              g = _context.sent;
              g.sort(function (u, y) {
                return u.status.end - y.status.end;
              });
              v = g.reduce(function (u, y) {
                return u.concat(y.books);
              }, n.books);
              if (!(t.filter && (v = v.filter(t.filter)), t.limit && (v = v.slice(0, t.limit)), t.groupBy)) {
                _context.next = 18;
                break;
              }
              _u = v.reduce(function (h, L) {
                var C;
                var _ = String((C = L.dateRead || L.dateAdded) == null ? void 0 : C.getFullYear());
                return h[_] = h[_] || [], h[_].push(L), h;
              }, {}), y = [];
              for (h in _u) {
                y.push({
                  title: h,
                  books: _u[h]
                });
              }
              return _context.abrupt("return", (y.sort(function (h, L) {
                return Number(L.title) - Number(h.title);
              }), y));
            case 18:
              return _context.abrupt("return", [{
                title: Be,
                books: v
              }]);
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function _t(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  De = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, n) {
      var o, d, l, _Et, g, v, m;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              o = gt(n, t);
              o.searchParams.append("page", String(t));
              _context2.next = 4;
              return window.fetch(o.toString(), {
                headers: {
                  accept: "text/javascript"
                }
              });
            case 4:
              d = _context2.sent;
              if (!(d.status === 204)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", {
                books: [],
                status: {
                  end: t * 30,
                  total: 0
                }
              });
            case 7:
              _context2.next = 9;
              return d.text();
            case 9:
              l = _context2.sent;
              _Et = Et(l);
              g = _Et.html;
              v = _Et.status;
              m = "<table>".concat(g, "</table>");
              return _context2.abrupt("return", {
                books: yt(m, n.width),
                status: v
              });
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function De(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(),
  Et = function Et(t) {
    var v, m, u, y;
    var _t$split = t.split("\n"),
      _t$split2 = _slicedToArray(_t$split, 2),
      n = _t$split2[0],
      o = _t$split2[1],
      d = n.replace('Element.insert("booksBody", ', "").replace(" });", "}").replace("bottom", '"bottom"'),
      l = JSON.parse(d).bottom,
      g = o.match( /*#__PURE__*/_wrapRegExp(/(\d*) of (\d*) loaded/, {
        end: 1,
        total: 2
      }));
    return {
      html: l,
      status: {
        end: parseInt((m = (v = g == null ? void 0 : g.groups) == null ? void 0 : v.end) != null ? m : "0"),
        total: parseInt((y = (u = g == null ? void 0 : g.groups) == null ? void 0 : u.total) != null ? y : "0")
      }
    };
  },
  Rt = function Rt(t) {
    var n = t.userId,
      o = t.limit,
      d = t.order,
      l = t.search,
      g = t.shelf,
      v = t.sort,
      _B = B([]),
      _B2 = _slicedToArray(_B, 2),
      m = _B2[0],
      u = _B2[1],
      _B3 = B(!1),
      _B4 = _slicedToArray(_B3, 2),
      y = _B4[0],
      h = _B4[1],
      _B5 = B(null),
      _B6 = _slicedToArray(_B5, 2),
      L = _B6[0],
      _ = _B6[1],
      C = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var P;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  h(!0), _(null);
                  _context3.prev = 1;
                  _context3.next = 4;
                  return _t(t);
                case 4:
                  P = _context3.sent;
                  u(P);
                  _context3.next = 11;
                  break;
                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3["catch"](1);
                  _(_context3.t0);
                case 11:
                  _context3.prev = 11;
                  h(!1);
                  return _context3.finish(11);
                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[1, 8, 11, 14]]);
        }));
        return function C() {
          return _ref3.apply(this, arguments);
        };
      }();
    return We(function () {
      !n || C();
    }, [n, o, d, l, g, v]), {
      books: m,
      loading: y,
      error: L
    };
  },
  Ct = "_book_1pxem_1",
  kt = "_details_1pxem_5",
  St = "_title_1pxem_9",
  Mt = "_subtitle_1pxem_15",
  Tt = "_author_1pxem_19",
  W = {
    book: Ct,
    details: kt,
    title: St,
    subtitle: Mt,
    author: Tt
  };
var ve = {
    exports: {}
  },
  Y = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ne;
function xt() {
  if (Ne) return Y;
  Ne = 1;
  var t = Ue,
    n = Symbol.for("react.element"),
    o = Symbol.for("react.fragment"),
    d = Object.prototype.hasOwnProperty,
    l = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    g = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function v(m, u, y) {
    var h,
      L = {},
      _ = null,
      C = null;
    y !== void 0 && (_ = "" + y), u.key !== void 0 && (_ = "" + u.key), u.ref !== void 0 && (C = u.ref);
    for (h in u) {
      d.call(u, h) && !g.hasOwnProperty(h) && (L[h] = u[h]);
    }
    if (m && m.defaultProps) for (h in u = m.defaultProps, u) {
      L[h] === void 0 && (L[h] = u[h]);
    }
    return {
      $$typeof: n,
      type: m,
      key: _,
      ref: C,
      props: L,
      _owner: l.current
    };
  }
  return Y.Fragment = o, Y.jsx = v, Y.jsxs = v, Y;
}
var U = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function Pt() {
  return Ie || (Ie = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Ue,
      n = Symbol.for("react.element"),
      o = Symbol.for("react.portal"),
      d = Symbol.for("react.fragment"),
      l = Symbol.for("react.strict_mode"),
      g = Symbol.for("react.profiler"),
      v = Symbol.for("react.provider"),
      m = Symbol.for("react.context"),
      u = Symbol.for("react.forward_ref"),
      y = Symbol.for("react.suspense"),
      h = Symbol.for("react.suspense_list"),
      L = Symbol.for("react.memo"),
      _ = Symbol.for("react.lazy"),
      C = Symbol.for("react.offscreen"),
      P = Symbol.iterator,
      z = "@@iterator";
    function q(e) {
      if (e === null || typeof e != "object") return null;
      var r = P && e[P] || e[z];
      return typeof r == "function" ? r : null;
    }
    var w = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(e) {
      {
        for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) {
          a[s - 1] = arguments[s];
        }
        V("error", e, a);
      }
    }
    function V(e, r, a) {
      {
        var s = w.ReactDebugCurrentFrame,
          p = s.getStackAddendum();
        p !== "" && (r += "%s", a = a.concat([p]));
        var b = a.map(function (f) {
          return String(f);
        });
        b.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var Z = !1,
      G = !1,
      J = !1,
      H = !1,
      X = !1,
      D;
    D = Symbol.for("react.module.reference");
    function K(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === d || e === g || X || e === l || e === y || e === h || H || e === C || Z || G || J || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === L || e.$$typeof === v || e.$$typeof === m || e.$$typeof === u || e.$$typeof === D || e.getModuleId !== void 0));
    }
    function Q(e, r, a) {
      var s = e.displayName;
      if (s) return s;
      var p = r.displayName || r.name || "";
      return p !== "" ? a + "(" + p + ")" : a;
    }
    function N(e) {
      return e.displayName || "Context";
    }
    function T(e) {
      if (e == null) return null;
      if (typeof e.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function") return e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case d:
          return "Fragment";
        case o:
          return "Portal";
        case g:
          return "Profiler";
        case l:
          return "StrictMode";
        case y:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof e == "object") switch (e.$$typeof) {
        case m:
          var r = e;
          return N(r) + ".Consumer";
        case v:
          var a = e;
          return N(a._context) + ".Provider";
        case u:
          return Q(e, e.render, "ForwardRef");
        case L:
          var s = e.displayName || null;
          return s !== null ? s : T(e.type) || "Memo";
        case _:
          {
            var p = e,
              b = p._payload,
              f = p._init;
            try {
              return T(f(b));
            } catch (_unused) {
              return null;
            }
          }
      }
      return null;
    }
    var O = Object.assign,
      I = 0,
      he,
      me,
      pe,
      ge,
      ye,
      be,
      Le;
    function _e() {}
    _e.__reactDisabledLog = !0;
    function ze() {
      {
        if (I === 0) {
          he = console.log, me = console.info, pe = console.warn, ge = console.error, ye = console.group, be = console.groupCollapsed, Le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: _e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        I++;
      }
    }
    function qe() {
      {
        if (I--, I === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, e, {
              value: he
            }),
            info: O({}, e, {
              value: me
            }),
            warn: O({}, e, {
              value: pe
            }),
            error: O({}, e, {
              value: ge
            }),
            group: O({}, e, {
              value: ye
            }),
            groupCollapsed: O({}, e, {
              value: be
            }),
            groupEnd: O({}, e, {
              value: Le
            })
          });
        }
        I < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = w.ReactCurrentDispatcher,
      se;
    function ee(e, r, a) {
      {
        if (se === void 0) try {
          throw Error();
        } catch (p) {
          var s = p.stack.trim().match(/\n( *(at )?)/);
          se = s && s[1] || "";
        }
        return "\n" + se + e;
      }
    }
    var oe = !1,
      te;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Ve();
    }
    function Ee(e, r) {
      if (!e || oe) return "";
      {
        var a = te.get(e);
        if (a !== void 0) return a;
      }
      var s;
      oe = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = ie.current, ie.current = null, ze();
      try {
        if (r) {
          var f = function f() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function set() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (j) {
              s = j;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (j) {
              s = j;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            s = j;
          }
          e();
        }
      } catch (j) {
        if (j && s && typeof j.stack == "string") {
          for (var c = j.stack.split("\n"), S = s.stack.split("\n"), E = c.length - 1, R = S.length - 1; E >= 1 && R >= 0 && c[E] !== S[R];) {
            R--;
          }
          for (; E >= 1 && R >= 0; E--, R--) {
            if (c[E] !== S[R]) {
              if (E !== 1 || R !== 1) do {
                if (E--, R--, R < 0 || c[E] !== S[R]) {
                  var x = "\n" + c[E].replace(" at new ", " at ");
                  return e.displayName && x.includes("<anonymous>") && (x = x.replace("<anonymous>", e.displayName)), typeof e == "function" && te.set(e, x), x;
                }
              } while (E >= 1 && R >= 0);
              break;
            }
          }
        }
      } finally {
        oe = !1, ie.current = b, qe(), Error.prepareStackTrace = p;
      }
      var $ = e ? e.displayName || e.name : "",
        $e = $ ? ee($) : "";
      return typeof e == "function" && te.set(e, $e), $e;
    }
    function Ze(e, r, a) {
      return Ee(e, !1);
    }
    function Ge(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function re(e, r, a) {
      if (e == null) return "";
      if (typeof e == "function") return Ee(e, Ge(e));
      if (typeof e == "string") return ee(e);
      switch (e) {
        case y:
          return ee("Suspense");
        case h:
          return ee("SuspenseList");
      }
      if (typeof e == "object") switch (e.$$typeof) {
        case u:
          return Ze(e.render);
        case L:
          return re(e.type, r, a);
        case _:
          {
            var s = e,
              p = s._payload,
              b = s._init;
            try {
              return re(b(p), r, a);
            } catch (_unused2) {}
          }
      }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty,
      Re = {},
      Ce = w.ReactDebugCurrentFrame;
    function ne(e) {
      if (e) {
        var r = e._owner,
          a = re(e.type, e._source, r ? r.type : null);
        Ce.setExtraStackFrame(a);
      } else Ce.setExtraStackFrame(null);
    }
    function Je(e, r, a, s, p) {
      {
        var b = Function.call.bind(ae);
        for (var f in e) {
          if (b(e, f)) {
            var c = void 0;
            try {
              if (typeof e[f] != "function") {
                var S = Error((s || "React class") + ": " + a + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw S.name = "Invariant Violation", S;
              }
              c = e[f](r, f, s, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              c = E;
            }
            c && !(c instanceof Error) && (ne(p), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", a, f, typeof c), ne(null)), c instanceof Error && !(c.message in Re) && (Re[c.message] = !0, ne(p), k("Failed %s type: %s", a, c.message), ne(null));
          }
        }
      }
    }
    var He = Array.isArray;
    function le(e) {
      return He(e);
    }
    function Xe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag,
          a = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function Ke(e) {
      try {
        return ke(e), !1;
      } catch (_unused3) {
        return !0;
      }
    }
    function ke(e) {
      return "" + e;
    }
    function Se(e) {
      if (Ke(e)) return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe(e)), ke(e);
    }
    var F = w.ReactCurrentOwner,
      Qe = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      Me,
      Te,
      ue;
    ue = {};
    function et(e) {
      if (ae.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.ref !== void 0;
    }
    function tt(e) {
      if (ae.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function rt(e, r) {
      if (typeof e.ref == "string" && F.current && r && F.current.stateNode !== r) {
        var a = T(F.current.type);
        ue[a] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(F.current.type), e.ref), ue[a] = !0);
      }
    }
    function at(e, r) {
      {
        var a = function a() {
          Me || (Me = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: a,
          configurable: !0
        });
      }
    }
    function nt(e, r) {
      {
        var a = function a() {
          Te || (Te = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: a,
          configurable: !0
        });
      }
    }
    var it = function it(e, r, a, s, p, b, f) {
      var c = {
        $$typeof: n,
        type: e,
        key: r,
        ref: a,
        props: f,
        _owner: b
      };
      return c._store = {}, Object.defineProperty(c._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(c, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(c, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(c.props), Object.freeze(c)), c;
    };
    function st(e, r, a, s, p) {
      {
        var b,
          f = {},
          c = null,
          S = null;
        a !== void 0 && (Se(a), c = "" + a), tt(r) && (Se(r.key), c = "" + r.key), et(r) && (S = r.ref, rt(r, p));
        for (b in r) {
          ae.call(r, b) && !Qe.hasOwnProperty(b) && (f[b] = r[b]);
        }
        if (e && e.defaultProps) {
          var E = e.defaultProps;
          for (b in E) {
            f[b] === void 0 && (f[b] = E[b]);
          }
        }
        if (c || S) {
          var R = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          c && at(f, R), S && nt(f, R);
        }
        return it(e, c, S, p, s, F.current, f);
      }
    }
    var ce = w.ReactCurrentOwner,
      xe = w.ReactDebugCurrentFrame;
    function A(e) {
      if (e) {
        var r = e._owner,
          a = re(e.type, e._source, r ? r.type : null);
        xe.setExtraStackFrame(a);
      } else xe.setExtraStackFrame(null);
    }
    var fe;
    fe = !1;
    function de(e) {
      return typeof e == "object" && e !== null && e.$$typeof === n;
    }
    function Pe() {
      {
        if (ce.current) {
          var e = T(ce.current.type);
          if (e) return "\n\nCheck the render method of `" + e + "`.";
        }
        return "";
      }
    }
    function ot(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""),
            a = e.lineNumber;
          return "\n\nCheck your code at " + r + ":" + a + ".";
        }
        return "";
      }
    }
    var Oe = {};
    function lt(e) {
      {
        var r = Pe();
        if (!r) {
          var a = typeof e == "string" ? e : e.displayName || e.name;
          a && (r = "\n\nCheck the top-level render call using <" + a + ">.");
        }
        return r;
      }
    }
    function we(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null) return;
        e._store.validated = !0;
        var a = lt(r);
        if (Oe[a]) return;
        Oe[a] = !0;
        var s = "";
        e && e._owner && e._owner !== ce.current && (s = " It was passed a child from " + T(e._owner.type) + "."), A(e), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, s), A(null);
      }
    }
    function je(e, r) {
      {
        if (typeof e != "object") return;
        if (le(e)) for (var a = 0; a < e.length; a++) {
          var s = e[a];
          de(s) && we(s, r);
        } else if (de(e)) e._store && (e._store.validated = !0);else if (e) {
          var p = q(e);
          if (typeof p == "function" && p !== e.entries) for (var b = p.call(e), f; !(f = b.next()).done;) {
            de(f.value) && we(f.value, r);
          }
        }
      }
    }
    function ut(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string") return;
        var a;
        if (typeof r == "function") a = r.propTypes;else if (typeof r == "object" && (r.$$typeof === u || r.$$typeof === L)) a = r.propTypes;else return;
        if (a) {
          var s = T(r);
          Je(a, e.props, "prop", s, e);
        } else if (r.PropTypes !== void 0 && !fe) {
          fe = !0;
          var p = T(r);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ct(e) {
      {
        for (var r = Object.keys(e.props), a = 0; a < r.length; a++) {
          var s = r[a];
          if (s !== "children" && s !== "key") {
            A(e), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), A(null);
            break;
          }
        }
        e.ref !== null && (A(e), k("Invalid attribute `ref` supplied to `React.Fragment`."), A(null));
      }
    }
    function Ae(e, r, a, s, p, b) {
      {
        var f = K(e);
        if (!f) {
          var c = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S = ot(p);
          S ? c += S : c += Pe();
          var E;
          e === null ? E = "null" : le(e) ? E = "array" : e !== void 0 && e.$$typeof === n ? (E = "<" + (T(e.type) || "Unknown") + " />", c = " Did you accidentally export a JSX literal instead of a component?") : E = typeof e, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, c);
        }
        var R = st(e, r, a, p, b);
        if (R == null) return R;
        if (f) {
          var x = r.children;
          if (x !== void 0) if (s) {
            if (le(x)) {
              for (var $ = 0; $ < x.length; $++) {
                je(x[$], e);
              }
              Object.freeze && Object.freeze(x);
            } else k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else je(x, e);
        }
        return e === d ? ct(R) : ut(R), R;
      }
    }
    function ft(e, r, a) {
      return Ae(e, r, a, !0);
    }
    function dt(e, r, a) {
      return Ae(e, r, a, !1);
    }
    var vt = dt,
      ht = ft;
    U.Fragment = d, U.jsx = vt, U.jsxs = ht;
  }()), U;
}
(function (t) {
  process.env.NODE_ENV === "production" ? t.exports = xt() : t.exports = Pt();
})(ve);
var i = ve.exports.jsx,
  M = ve.exports.jsxs,
  Ot = function Ot() {
    return /* @__PURE__ */i("div", {
      children: /* @__PURE__ */M("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          width: "100%"
        },
        viewBox: "0 0 170 250",
        children: [/* @__PURE__ */i("path", {
          style: {
            fill: "#ffffff",
            stroke: "none"
          },
          d: "M0 0L0 240L170 240L170 0L0 0z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M82 61L83 62L82 61z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#808080",
            stroke: "none"
          },
          d: "M93 145C79.6257 141.205 63.417 138.566 51.0401 132.235C46.9518 130.144 41.5316 121.554 47.3179 118.068C50.6475 116.062 56.6487 119.038 60 120L80 125.579C83.4433 126.56 87.3543 128.206 90.9961 127.812C95.0859 127.369 97.4951 123.882 100 120.999C105.227 114.984 110.546 109.055 115.729 103C121.144 96.673 126.701 90.4409 131.981 84C134.072 81.4479 137.039 77.7432 134.957 74.3032C133.56 71.995 130.402 71.472 128 70.885C122.364 69.5077 116.654 68.419 111 67.1188C104.688 65.6674 98.3344 64.3539 92 63C89.2014 62.4019 85.8624 61.1288 83 61.9159C76.588 63.679 71.3975 72.3808 67.0355 77C63.9636 80.253 61.0812 83.6855 58.0748 87C47.4655 98.6969 26.6977 117.282 38.9699 134.907C42.2427 139.607 47.7809 141.351 53 142.975C62.2818 145.863 71.6555 148.463 81 151.141C85.2587 152.362 91.5271 155.739 95.9105 153.731C99.4375 152.115 102.007 147.89 104.414 145C109.434 138.971 114.602 133.068 119.576 127C126.295 118.802 135.654 111.058 135.454 100C135.402 97.0889 136.725 92.9476 133.685 91.0471C129.481 88.4187 126.946 93.731 126.329 97.0008C122.619 116.665 101.124 127.263 93 145z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M85 61L86 62L85 61M112 67L113 68L112 67M117 68L118 69L117 68M72 71L73 72L72 71z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#555555",
            stroke: "none"
          },
          d: "M80 78L81 79L80 78z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#ffffff",
            stroke: "none"
          },
          d: "M77 84C83.6869 85.3802 90.3853 87.037 97 88.7315C103.67 90.4403 109.474 92.3156 113 85C105.981 83.9673 98.9214 81.7562 92 80.1157C85.4991 78.5749 80.3963 76.9541 77 84z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M110 89L111 90L110 89M54 91L55 92L54 91z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#aaaaaa",
            stroke: "none"
          },
          d: "M122 108L123 109L122 108z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M121 109L122 110L121 109M37 112L38 113L37 112M116 115L117 116L116 115z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#555555",
            stroke: "none"
          },
          d: "M103 116L104 117L103 116M46 117L47 118L46 117M45 118L46 119L45 118z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M124 120L125 121L124 120M69 122L70 123L69 122M37 132L38 133L37 132M50 132L51 133L50 132M42 138L43 139L42 138M109 138L110 139L109 138z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#555555",
            stroke: "none"
          },
          d: "M87 143L88 144L87 143z"
        }), /* @__PURE__ */i("path", {
          style: {
            fill: "#000000",
            stroke: "none"
          },
          d: "M99 150L100 151L99 150M82 151L83 152L82 151z"
        })]
      })
    });
  },
  wt = "_image_27awu_1",
  jt = "_cover_27awu_13",
  Fe = {
    image: wt,
    cover: jt
  },
  At = function At(_ref4) {
    var t = _ref4.book,
      n = _ref4.options;
    var h;
    var _B7 = B({
        error: !1
      }),
      _B8 = _slicedToArray(_B7, 2),
      o = _B8[0],
      d = _B8[1],
      _B9 = B(!1),
      _B10 = _slicedToArray(_B9, 2),
      l = _B10[0],
      g = _B10[1],
      v = mt(null);
    We(function () {
      var L = new window.IntersectionObserver(function (_) {
        var C = _[0].isIntersecting;
        C && L.disconnect(), g(C);
      }, {
        threshold: 0
      });
      v.current && L.observe(v.current);
    }, []);
    var m = t.imageUrl;
    m || (t.isbn ? m = "https://images-na.ssl-images-amazon.com/images/P/".concat(t.isbn, ".01._SCLZZZZZZZ_.jpg") : t.asin && (m = "https://images-na.ssl-images-amazon.com/images/P/".concat(t.asin, ".01._SCLZZZZZZZ_.jpg")));
    var u = function u() {
        return d({
          error: !0
        });
      },
      y = pt(function () {
        return function (L) {
          var C;
          var _ = "";
          return (C = n == null ? void 0 : n.displayOptions) != null && C.hideBackgroundImages || l && (_ = "url(\"".concat(L, "\")")), {
            backgroundImage: _,
            opacity: l ? 1 : 0
          };
        };
      }, [m, l, (h = n == null ? void 0 : n.displayOptions) == null ? void 0 : h.hideBackgroundImages]);
    return /* @__PURE__ */i("div", {
      ref: v,
      className: "rgs-cover ".concat(Fe.cover),
      style: y(m),
      children: o.error ? /* @__PURE__ */i("div", {
        className: "rgs-placeholder",
        "data-testid": "placeholder",
        children: /* @__PURE__ */i(Ot, {})
      }) : /* @__PURE__ */i("div", {
        children: /* @__PURE__ */i("img", {
          alt: t.title,
          className: "rgs-image ".concat(Fe.image),
          src: m,
          loading: "lazy",
          onError: u
        })
      })
    });
  },
  $t = function $t(_ref5) {
    var t = _ref5.stars;
    if (t) {
      var n = new Array(t).fill("\u2605");
      return /* @__PURE__ */i("div", {
        role: "presentation",
        children: n.map(function (o, d) {
          return /* @__PURE__ */i("span", {
            children: o
          }, d);
        })
      });
    }
    return null;
  },
  Dt = function Dt(_ref6) {
    var t = _ref6.book,
      n = _ref6.options;
    var l;
    var o = (l = n == null ? void 0 : n.displayOptions) == null ? void 0 : l.hideDetails;
    if (o === !0) return null;
    var d = function d(g) {
      return o === !1 ? !0 : !(o != null && o[g]);
    };
    return /* @__PURE__ */M("div", {
      className: "rgs-details ".concat(W.details),
      children: [d("title") && /* @__PURE__ */i("div", {
        className: "rgs-title ".concat(W.title),
        children: t.title
      }), d("subtitle") && t.subtitle ? /* @__PURE__ */i("div", {
        className: "rgs-subtitle ".concat(W.subtitle),
        children: t.subtitle
      }) : null, d("author") && /* @__PURE__ */i("div", {
        className: "rgs-author ".concat(W.author),
        children: t.author
      }), d("rating") && /* @__PURE__ */i($t, {
        stars: t.rating
      })]
    });
  },
  Nt = function Nt(_ref7) {
    var t = _ref7.book,
      n = _ref7.options;
    return t ? /* @__PURE__ */M("div", {
      children: [/* @__PURE__ */i("div", {
        className: "rgs-book ".concat(W.book),
        title: t.title,
        children: /* @__PURE__ */i("a", {
          href: t.link,
          target: "_blank",
          rel: "nofollow noreferrer",
          children: /* @__PURE__ */i(At, {
            book: t,
            options: n
          })
        })
      }), /* @__PURE__ */i(Dt, {
        book: t,
        options: n
      })]
    }) : null;
  },
  It = "_shelf_186u5_1",
  Ft = {
    shelf: It
  },
  Yt = function Yt(t) {
    var d, l, g, v, m, u, y;
    var _ref8 = t || {},
      n = _ref8.width;
    typeof n == "number" && (n = "".concat(n, "px")), n = n || "170px";
    var o = (d = t == null ? void 0 : t.displayOptions) != null && d.hideDetails ? "calc(".concat(n, " / 8)") : "calc(".concat(n, " / 6)");
    return {
      gridTemplateColumns: "repeat(auto-fill, minmax(".concat(n, ", 1fr))"),
      columnGap: (v = (g = (l = t == null ? void 0 : t.displayOptions) == null ? void 0 : l.gridStyle) == null ? void 0 : g.columnGap) != null ? v : o,
      rowGap: (y = (u = (m = t == null ? void 0 : t.displayOptions) == null ? void 0 : m.gridStyle) == null ? void 0 : u.rowGap) != null ? y : o
    };
  },
  Ut = function Ut(_ref9) {
    var t = _ref9.books,
      n = _ref9.options;
    return /* @__PURE__ */i("div", {
      className: "rgs-shelf ".concat(Ft.shelf),
      style: Yt(n),
      role: "grid",
      children: t.map(function (o) {
        return /* @__PURE__ */i(Nt, {
          book: o,
          options: n
        }, o.id);
      })
    });
  },
  Wt = "_groupTitle_1e2wf_1",
  Bt = "_group_1e2wf_1",
  Ye = {
    groupTitle: Wt,
    group: Bt
  },
  zt = function zt() {
    return /* @__PURE__ */i("div", {
      style: {
        textAlign: "center"
      },
      children: /* @__PURE__ */M("svg", {
        width: 50,
        height: 50,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        children: [/* @__PURE__ */i("path", {
          d: "M20 25h60v50H20z",
          fill: "#fdfdfd",
          stroke: "#85a2b6"
        }), /* @__PURE__ */M("path", {
          d: "M50 25l9.421-3.43v56.86L50 75",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75",
            keyTimes: "0;0.5;0.501;1",
            dur: 1.6,
            begin: "0s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "1;1;0;0",
            keyTimes: "0;0.5;0.5001;1",
            dur: 1.6,
            begin: "0s",
            repeatCount: "indefinite"
          })]
        }), /* @__PURE__ */M("path", {
          d: "M50 25h30v50H50",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75",
            keyTimes: "0;0.5;0.501;1",
            dur: 1.6,
            begin: "-0.2656s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "1;1;0;0",
            keyTimes: "0;0.5;0.5001;1",
            dur: 1.6,
            begin: "-0.2656s",
            repeatCount: "indefinite"
          })]
        }), /* @__PURE__ */M("path", {
          d: "M50 25h30v50H50",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75",
            keyTimes: "0;0.5;0.501;1",
            dur: 1.6,
            begin: "-0.528s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "1;1;0;0",
            keyTimes: "0;0.5;0.5001;1",
            dur: 1.6,
            begin: "-0.528s",
            repeatCount: "indefinite"
          })]
        }), /* @__PURE__ */M("path", {
          d: "M50 25l-10.379-3.27v56.54L50 75",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75",
            keyTimes: "0;0.499;0.5;1",
            dur: 1.6,
            begin: "-0.528s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "0;0;1;1",
            keyTimes: "0;0.4999;0.5;1",
            dur: 1.6,
            begin: "-0.528s",
            repeatCount: "indefinite"
          })]
        }), /* @__PURE__ */M("path", {
          d: "M50 25l-.539-4.91v59.82L50 75",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75",
            keyTimes: "0;0.499;0.5;1",
            dur: 1.6,
            begin: "-0.2656s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "0;0;1;1",
            keyTimes: "0;0.4999;0.5;1",
            dur: 1.6,
            begin: "-0.2656s",
            repeatCount: "indefinite"
          })]
        }), /* @__PURE__ */M("path", {
          d: "M50 25H20v50h30",
          fill: "#fdfdfd",
          stroke: "#85a2b6",
          children: [/* @__PURE__ */i("animate", {
            attributeName: "d",
            calcMode: "linear",
            values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75",
            keyTimes: "0;0.499;0.5;1",
            dur: 1.6,
            begin: "0s",
            repeatCount: "indefinite"
          }), /* @__PURE__ */i("animate", {
            attributeName: "opacity",
            calcMode: "linear",
            values: "0;0;1;1",
            keyTimes: "0;0.4999;0.5;1",
            dur: 1.6,
            begin: "0s",
            repeatCount: "indefinite"
          })]
        })]
      })
    });
  },
  Vt = function Vt(t) {
    var _Rt = Rt(t),
      n = _Rt.books,
      o = _Rt.loading,
      d = _Rt.error;
    return /* @__PURE__ */M("div", {
      className: "rgs-shelf",
      children: [o ? /* @__PURE__ */i(zt, {}) : /* @__PURE__ */i("div", {
        children: n.map(function (l) {
          return /* @__PURE__ */M("div", {
            className: "rgs-group ".concat(Ye.group),
            children: [l.title !== Be && /* @__PURE__ */M("div", {
              className: "rgs-group-title ".concat(Ye.groupTitle),
              children: [l.title, " ", /* @__PURE__ */M("small", {
                children: ["(", l.books.length, " ", l.books.length === 1 ? "book" : "books", ")"]
              })]
            }), /* @__PURE__ */i(Ut, {
              books: l.books,
              options: t
            })]
          }, l.title);
        })
      }), d && /* @__PURE__ */i("div", {
        children: "Sorry, we couldn't load books right now"
      })]
    });
  };
export { Vt as GoodreadsBookshelf, Vt as default };